import { Component } from '@angular/core';

@Component({
  selector: 'app-factoring',
  templateUrl: './factoring.component.html',
  styleUrls: ['./factoring.component.css']
})
export class FactoringComponent   {

  
}
